import foodAdditiveReducer from "./foodAdditiveReducer";

const foodAdditiveReducers = {
    foodAdditive: foodAdditiveReducer,
}

export default foodAdditiveReducers;